import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { CurrencyInrIcon } from "@phosphor-icons/react";
import { toast } from "sonner";

const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const ReservationRateEdit = ({ res, onSaved, testIdPrefix = "res-rate" }) => {
  const [open, setOpen] = useState(false);
  const [rate, setRate] = useState("");
  const [busy, setBusy] = useState(false);
  if (!res || !["booked", "checked_in"].includes(res.status)) return null;

  const nights = Math.max(1, Math.round((new Date(res.check_out) - new Date(res.check_in)) / 86400000));
  const n = Number(rate);
  const save = async () => {
    if (!(n > 0)) return toast.error("Enter a rate greater than 0");
    setBusy(true);
    try {
      await api.patch(`/reservations/${res.id}`, { rate_override: n });
      toast.success(`Rate updated to ${inr(n)} / night`);
      setOpen(false);
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Rate update failed");
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button type="button" size="sm" variant="outline" onClick={() => { setRate(String(res.rate_per_night || "")); setOpen(true); }} data-testid={`${testIdPrefix}-edit-btn`}>
        <CurrencyInrIcon size={14} className="mr-1" /> Edit rate
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid={`${testIdPrefix}-dialog`}>
          <DialogHeader><DialogTitle>Change nightly rate</DialogTitle></DialogHeader>
          <div className="space-y-3 text-sm">
            <p className="text-muted-foreground">Current: {inr(res.rate_per_night)} × {nights} night{nights !== 1 ? "s" : ""} = {inr(res.total_amount)}</p>
            <div>
              <Label>New rate per night (₹)</Label>
              <Input type="number" min={1} value={rate} onChange={(e) => setRate(e.target.value)} data-testid={`${testIdPrefix}-input`} />
            </div>
            {n > 0 && <p data-testid={`${testIdPrefix}-preview`}>New room total: <b className="font-mono-plex">{inr(n * nights)}</b> (applies to all nights; open invoice updates too)</p>}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid={`${testIdPrefix}-cancel`}>Cancel</Button>
            <Button onClick={save} disabled={busy} data-testid={`${testIdPrefix}-save`}>{busy ? "Saving…" : "Update rate"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
